import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Loader2 } from 'lucide-react';

/**
 * OIDC callback page — handles the redirect from OneLogin after authentication.
 * Once the token is processed, redirects the user to /portal.
 */
export function CallbackPage() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Once auth is no longer loading and user is authenticated, redirect
    if (!auth.isLoading && auth.isAuthenticated) {
      navigate('/portal', { replace: true });
    }
  }, [auth.isLoading, auth.isAuthenticated, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center space-y-4">
        <Loader2 className="w-8 h-8 text-primary animate-spin mx-auto" />
        <p className="text-gray-600">Signing you in...</p>
      </div>
    </div>
  );
}
